/** Case à cocher (design system, CaseACocher) : une option indépendante, libellé cliquable. */
import { useEffect, useId, useRef } from 'react';
import { Icone } from './Icone';

export interface CaseACocherProps {
  libelle?: string;
  etiquette?: string;
  description?: string;
  coche: boolean;
  onChange: (coche: boolean) => void;
  indeterminee?: boolean;
  desactivee?: boolean;
  id?: string;
}

export function CaseACocher({
  libelle,
  etiquette,
  description,
  coche,
  onChange,
  indeterminee = false,
  desactivee = false,
  id,
}: CaseACocherProps) {
  const genere = useId();
  const idEntree = id ?? `case-${genere}`;
  const entree = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (entree.current) entree.current.indeterminate = indeterminee;
  }, [indeterminee]);
  return (
    <div className="fc-case-a-cocher">
      <span className="fc-case-a-cocher__boite">
        <input
          ref={entree}
          type="checkbox"
          className="fc-case-a-cocher__entree"
          id={idEntree}
          checked={coche}
          disabled={desactivee}
          aria-label={libelle ? undefined : etiquette}
          aria-describedby={description ? `${idEntree}-aide` : undefined}
          data-indeterminee={indeterminee ? '' : undefined}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className="fc-case-a-cocher__carre" aria-hidden="true">
          <Icone nom="check" className="fc-case-a-cocher__coche" />
          <Icone nom="minus" className="fc-case-a-cocher__trait" />
        </span>
      </span>
      {(libelle || description) && (
        <span className="fc-case-a-cocher__textes">
          {libelle && (
            <label className="fc-case-a-cocher__libelle" htmlFor={idEntree}>
              {libelle}
            </label>
          )}
          {description && (
            <span className="fc-case-a-cocher__description" id={`${idEntree}-aide`}>
              {description}
            </span>
          )}
        </span>
      )}
    </div>
  );
}
